import { QUERIES } from '@repo/ui/queries';
import styled from 'styled-components';

export const NavigationComponentWrapper = styled.div`
  padding: var(--spacing-16) 24px;
  ${QUERIES.largeTabletAndUp} {
    padding: var(--spacing-24) 48px;
  }
`;

export const CategoryWrapper = styled.div`
  display: grid;
  width: 100%;

  gap: 12px;
  grid-template-columns: repeat(2, 1fr);

  ${QUERIES.largeTabletAndUp} {
    grid-template-columns: repeat(3, 1fr);
  }

  ${QUERIES.laptopAndUp} {
    gap: 24px;
    grid-template-columns: repeat(4, 1fr);
  }

  ${QUERIES.smallDesktopAndUp} {
    grid-template-columns: repeat(5, 1fr);
  }
`;
